'use client';

import React from 'react';
import CartItemsList from '@/ui/components/layout/cart/CartItemsList';
import OrderPriceSummary from '@/ui/components/shared/OrderPriceSummary';
import { CartItemVariant } from '@/ui/components/layout/cart/CartItem/types/CartItemVariant';
import { orderDetailsVariant } from '@/ui/components/layout/cart/CartItem/types/cartItemVariants';
import { CartItems } from '@/ui/store/cart/types/CartItems';
import { CostBreakdown } from '@/ui/components/pages/checkout/CheckoutForm/types/CostBreakdown';
import { PricingDisplayMode } from '@/ui/components/shared/OrderPriceSummary/types/PricingDisplayMode';
import { OrderPriceSummaryProps } from '@/ui/components/shared/OrderPriceSummary/types/OrderPriceSummaryProps';

type AccountOrderSummaryProps = {
  cartItems: CartItems;
  costBreakdown: CostBreakdown;
  currency?: string;
  variant?: CartItemVariant;
  pricingMode?: PricingDisplayMode;
  textSize?: OrderPriceSummaryProps['textSize'];
};

export default function AccountOrderSummary({
  cartItems,
  costBreakdown,
  currency,
  variant = orderDetailsVariant,
  pricingMode,
  textSize,
}: Readonly<AccountOrderSummaryProps>) {
  return (
    <>
      <CartItemsList cartItems={cartItems} disableUpdate variant={variant} currency={currency} />
      <div className="mt-2 w-full px-4 sm:px-6">
        <div className="h-px bg-neutral-10" />
      </div>
      <div className="mt-1">
        <OrderPriceSummary
          costBreakdown={costBreakdown}
          currency={currency}
          pricingMode={pricingMode}
          textSize={textSize}
        />
      </div>
    </>
  );
}
